<template>
    <div class="profile-about-blocks d-flex">

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{stats.supported_active_projects_count || 0}}</span>
                проектов <br> в реализации
            </div>

        </div>

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{stats.members_personal_pets_count || 0}}</span>
                животных <br> сотрудников
            </div>

        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{stats.supported_active_pets_count || 0}}</span>
                животных на <br>попечении
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{ stats.supported_projects_count || 0 }}</span>
                проектов <br>поддержано
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">
                    {{stats['donated_total']}} BYN
                </span>
                жертвуют
            </div>

        </div>

    </div>
</template>

<script>


export default {
    props: ['stats'],
    name: "OrganizationAbout",



}
</script>

<style scoped>

</style>
